import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, subTypeCode} = map.data

    if (! (
        'BODA2' === subTypeCode &&
        'SA_MAP' === mapTypeCode
    )) {
        return null
    }

    const onClick = () => map.commands.aiGenerateSrf(map.selectedNodes)

    return {
        label: '设计变更分析（专家模式）',
        onClick,
    }
}
